export enum Loading {
  Circle,
  Linear,
}
